import React from "react";

const RenderSelector = ({ onSelect }) => (
  <div className="fixed inset-0 w-full h-full z-50 select-none flex flex-col">
    {/* Texte de bienvenue centré */}
    <div
      className="w-full flex justify-center items-center py-8 pointer-events-none"
      style={{ position: "absolute", top: 0, left: 0, zIndex: 10 }}
    >
      <span className="text-2xl md:text-3xl font-semibold text-white bg-black/40 px-6 py-3 rounded-xl shadow-lg backdrop-blur-sm text-center">
        Bienvenue sur le portfolio de Fabien Lapert
        <br className="hidden md:block" />
        <span className="block mt-2">Sélectionnez votre expérience</span>
      </span>
    </div>
    {/* Deux moitiés */}
    <div className="flex flex-1 w-full h-full">
      <div
        className="flex-1 flex flex-col items-center justify-center bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900 cursor-pointer transition hover:brightness-110"
        onClick={() => onSelect("3d")}
        style={{ borderRight: "2px solid #fff" }}
      >
        <span className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg">
          Rendu 3D
        </span>
        <span className="text-lg md:text-xl text-indigo-200">
          Expérience immersive
        </span>
      </div>
      <div
        className="flex-1 flex flex-col items-center justify-center bg-white cursor-pointer transition hover:brightness-95"
        onClick={() => onSelect("classic")}
      >
        <span className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 drop-shadow-lg">
          Rendu classique
        </span>
        <span className="text-lg md:text-xl text-gray-500">
          Version simple et rapide
        </span>
      </div>
    </div>
  </div>
);

export default RenderSelector;
